import { action, makeObservable, observable } from 'mobx';

import ApiService from '../services/ApiService';

import { Loadable } from './models/Loadable';
import { Mandate } from './models/Mandate';
import { ISsoStore } from './SsoStore';

export interface IMandatesStore {
  readonly mandate: Loadable<Mandate>;

  tryLoadMandate(): void;
}

export default class MandatesStore implements IMandatesStore {
  @observable
  public mandate: Loadable<Mandate> = new Loadable<Mandate>();

  constructor(
    private apiService: ApiService,
    private ssoStore: ISsoStore
  ) {
    makeObservable(this);
  }

  @action.bound
  public tryLoadMandate(): void {
    if (!this.mandate.isInitial) {
      return;
    }
    this.mandate = Loadable.toLoadable(this.apiService.getMandate(this.ssoStore.customer.customerId));
  }
}
